import { motion } from "framer-motion";
import { FaAward, FaGlobe, FaLeaf, FaShippingFast } from "react-icons/fa";

const features = [
  { icon: <FaAward />, title: "Handcrafted", text: "Made by skilled Afghan artisans using traditional weaving techniques." },
  { icon: <FaLeaf />, title: "Natural Materials", text: "Quality wool and carefully selected natural fibers built for everyday living." },
  { icon: <FaShippingFast />, title: "Worldwide Shipping", text: "Carefully packed and shipped internationally with tracking." },
  { icon: <FaGlobe />, title: "Authentic Heritage", text: "Distinctive designs carrying generations of Afghan weaving heritage." },
];

export default function WhyChoose() {
  return (
    <section className="relative overflow-hidden bg-white py-16 sm:py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 grid gap-6 md:grid-cols-[1fr_auto] md:items-end sm:mb-14">
          <div className="max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#0F766E]">The A1 Rugs difference</p>
            <h2 className="mt-3 text-3xl font-bold tracking-tight text-[#173C39] sm:text-4xl lg:text-5xl">Craftsmanship you can feel.</h2>
            <p className="mt-5 text-base leading-7 text-slate-600 sm:text-lg">From the first thread to delivery at your door, we focus on authenticity, careful selection, and a straightforward buying experience.</p>
          </div>
          <div className="hidden rounded-2xl bg-[#F8F3E7] px-5 py-4 text-right md:block">
            <p className="text-2xl font-bold text-[#173C39]">Afghan</p>
            <p className="text-xs font-semibold uppercase tracking-widest text-[#0F766E]">Handmade heritage</p>
          </div>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
          {features.map((item, index) => (
            <motion.article key={item.title} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.2 }} transition={{ duration: 0.5, delay: index * 0.08 }} className="group rounded-[1.75rem] border border-slate-200 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#0F766E]/25 hover:shadow-xl sm:p-7">
              <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-[#E7F2F0] text-xl text-[#0F766E] transition-colors duration-300 group-hover:bg-[#0F766E] group-hover:text-white">{item.icon}</div>
              <h3 className="text-xl font-bold text-[#173C39]">{item.title}</h3>
              <p className="mt-3 text-sm leading-6 text-slate-600">{item.text}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
